import { render, staticRenderFns } from "./feedBackAdmView.vue?vue&type=template&id=0d411dca&scoped=true&"
import script from "./feedBackAdmView.vue?vue&type=script&lang=js&"
export * from "./feedBackAdmView.vue?vue&type=script&lang=js&"
import style0 from "./feedBackAdmView.vue?vue&type=style&index=0&id=0d411dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d411dca",
  null
  
)

export default component.exports